import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useLanguage } from '../../../../../../API/Context/LanguageContext';
import { useHealthBackgroundActions } from '../../../../../../API/Hooks/useHealthBackgroundActions';
import EnumSelect from '../../../../LoggedUserGeneral/ProfileOnboarding/Steps/Widgets/EnumSelect';
import { 
  ALLERGY_CATEGORY_MAP, 
  ALLERGY_SEVERITY_MAP,
  ALLERGY_CRITICALITY_MAP,
  ALLERGY_STATUS_MAP,
} from '../../../../../../ConfigFiles/maps/allergies_map';
import { 
  AllergyCategoryEnum, 
  AllergySeverityEnum,
  AllergyCriticalityEnum,
  AllergyStatusEnum, 
} from '../../../../../../Types/Enums/AllergyEnum';

export interface CreateAllergyModalProps {
  patientUsername?: string | undefined;
  show: boolean;
  onHide: () => void;
}

export const CreateAllergyModal: React.FC<CreateAllergyModalProps> = ({ show, onHide }) => {
  const { lan } = useLanguage();
  const currentLanKey = (lan as number) === 0 ? 0 : 1;
  const { addAllergy, loading } = useHealthBackgroundActions();

  const [allergen, setAllergen] = useState('');
  const [category, setCategory] = useState<number>(AllergyCategoryEnum.FOOD);
  const [severity, setSeverity] = useState<number>(AllergySeverityEnum.MILD);
  const [criticality, setCriticality] = useState<number>(AllergyCriticalityEnum.LOW);
  const [status, setStatus] = useState<number>(AllergyStatusEnum.ACTIVE);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!allergen.trim()) return;

    const res = await addAllergy({
      allergen: allergen.trim(),
      category: category as any,
      severity: severity as any,
      criticality: criticality as any,
      status: status as any,
    });

    if (res) {
      setAllergen('');
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{currentLanKey === 0 ? 'Registrar Nueva Alergia' : 'Register New Allergy'}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body className="d-flex flex-column gap-3">
          <Form.Group>
            <Form.Label className="fw-semibold">{currentLanKey === 0 ? 'Alergeno' : 'Allergen'}</Form.Label>
            <Form.Control
              type="text"
              required
              placeholder={currentLanKey === 0 ? 'Ej. Penicilina, Cacahuates...' : 'e.g. Penicillin, Peanuts...'}
              value={allergen}
              onChange={(e) => setAllergen(e.target.value)}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label className="fw-semibold">{currentLanKey === 0 ? 'Categoría' : 'Category'}</Form.Label>
            <EnumSelect 
              value={category} 
              options={ALLERGY_CATEGORY_MAP} 
              onChange={setCategory} 
              required={true} 
            />
          </Form.Group>

          <div className="row g-2">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label className="fw-semibold">{currentLanKey === 0 ? 'Severidad' : 'Severity'}</Form.Label>
                <EnumSelect 
                  value={severity} 
                  options={ALLERGY_SEVERITY_MAP} 
                  onChange={setSeverity} 
                  required={true} 
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group>
                <Form.Label className="fw-semibold">{currentLanKey === 0 ? 'Criticidad' : 'Criticality'}</Form.Label>
                <EnumSelect 
                  value={criticality} 
                  options={ALLERGY_CRITICALITY_MAP} 
                  onChange={setCriticality} 
                  required={true} 
                />
              </Form.Group>
            </div>
          </div>

          <Form.Group>
            <Form.Label className="fw-semibold">{currentLanKey === 0 ? 'Estado Inicial' : 'Initial Status'}</Form.Label>
            <EnumSelect 
              value={status} 
              options={ALLERGY_STATUS_MAP} 
              onChange={setStatus} 
              required={true} 
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            {currentLanKey === 0 ? 'Cancelar' : 'Cancel'}
          </Button>
          <Button type="submit" variant="primary" disabled={loading || !allergen.trim()}>
            {currentLanKey === 0 ? 'Guardar Alergia' : 'Save Allergy'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};